<template>
    <div class="Testquery">
        <div class="header">
            <div class="condition">

                <div class="item">
                    <!-- $t('original.languages164') -->
                    <span>{{ $t('original.languages110')}}</span>
                    <el-input v-model="params.from.searchData" clearable :placeholder="$t('original.languages568')"></el-input>
                </div>
                
                <div class="item">
                    <span>{{ $t('original.national')}}</span>
                    <el-select v-model="params.nation" clearable style="width:217px;">
                        <el-option v-for="item in nationList" :key="item.dicKey" :label="item.cDicValue" :value="item.dicKey"></el-option>
                    </el-select>
                </div>
                <div class="item">
                    <span>{{ $t('original.languages562')}}</span>
                    <el-date-picker clearable  style="width:217px;" v-model="params.from.testTime" type="daterange" value-format="yyyy-MM-dd"  :range-separator="$t('original.languages296')" :start-placeholder="$t('original.languages38')" :end-placeholder="$t('original.languages39')"></el-date-picker>
                </div>
                <div class="item">
                    <span>{{$t('original.Name_of_scale')}}</span>
                    <el-input v-model="params.from.scaleName" clearable :placeholder="$t('original.languages563')"></el-input>
                </div>
            </div>
            <div class="condition">

                <div class="item">
                    <span>{{$t('original.Release_theme')}}</span>
                    <el-select v-model="params.from.publishID" clearable style="width:217px;">
                        <el-option v-for="item in SubjectPublish" :label="item.PublishSubject" :value="item.PublishID" :key="item.PublishID"></el-option>
                    </el-select>
                </div>

                <div class="item">
                    <span>{{$t('original.Release_object')}}</span>
                    <el-cascader ref="wcascader" @change="Selected_to_shut_dow" @expand-change="bumen" v-model="params.from.objectS"
                filterable :options="optionsnew" :props="{ checkStrictly: true }" clearable></el-cascader>
                </div>

                <div class="item">
                    <!-- <span>入学年份：</span> -->
                    <span>{{$t('original.languages171')}}</span>
                    <el-select v-model="params.from.studyTime" clearable style="width:217px;">
                        <el-option v-for="item in YearList" :label="item" :value="item" :key="item"></el-option>
                    </el-select>
                </div>

                <div class="item">
                    <span>{{$t('original.languages175')}}</span>
                    <el-select v-model="params.study" clearable style="width:217px;">
                        <el-option :label="$t('original.languages570')" value="博士生"></el-option>
                        <el-option :label="$t('original.languages571')" value="硕士"></el-option>
                        <el-option :label="$t('original.languages572')" value="本科"></el-option>
                        <el-option :label="$t('original.languages573')" value="大专"></el-option>
                        <el-option :label="$t('original.languages574')" value="中专"></el-option>
                        <el-option :label="$t('original.languages575')" value="高中"></el-option>
                        <el-option :label="$t('original.languages576')" value="初中"></el-option>
                        <el-option :label="$t('original.languages577')" value="小学"></el-option>
                        <el-option :label="$t('original.languages578')" value="文盲"></el-option>
                        <el-option :label="$t('original.languages579')" value="其他"></el-option>
                    </el-select>
                </div>
            </div>

            <div class="condition">
                <div class="item">
                    <span>{{$t('original.gender')}}</span>
                    <el-select clearable v-model="params.sex" style="width:217px;">
                        <el-option :label="$t('original.languages6')" :value="0"></el-option>
                        <el-option :label="$t('original.languages5')" :value="1"></el-option>
                    </el-select>
                </div>
                <div class="item">
                    <span>{{$t('original.languages564')}}</span>
                    <el-select clearable v-model="params.ifTest" style="width:217px;">
                        <el-option :label="$t('original.languages173')" :value="0"></el-option>
                        <el-option :label="$t('original.languages172')" :value="1"></el-option>
                    </el-select>
                </div>
            </div>

            <div class="condition">
                <div class="item" style="width:auto;">
                    <span>{{$t('original.languages144')}}</span>
                    <el-checkbox-group v-model="params.from.warning" clearable style="display: inline-block;">
                        <el-checkbox label="重度">{{$t('original.languages129')}}</el-checkbox>
                        <el-checkbox label="较重">{{$t('original.languages580')}}</el-checkbox>
                        <el-checkbox label="中度">{{$t('original.languages130')}}</el-checkbox>
                        <el-checkbox label="轻度">{{$t('original.languages131')}}</el-checkbox>
                        <el-checkbox label="正常">{{$t('original.languages47')}}</el-checkbox>
                    </el-checkbox-group>
                </div>
                <div style="display: inline-block;margin-left: 30px;">
                    <el-button type="primary" @click="searchlist()">{{$t('original.languages470')}}</el-button>
                    <el-button @click="react">{{$t('original.reset')}}</el-button>
                </div>
            </div>
        </div>
        <div class="content">
            <el-button type="primary" @click="exoprtall">{{$t('original.Export_all')}}</el-button>
            <el-button type="primary" @click="clickexport">{{$t('original.Export_the_selected')}}</el-button>
            <el-table style="width: 100%;margin-top: 20px;" :data="queryscaletestlist" v-loading="loading"  @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="50"></el-table-column>
                <el-table-column type="index" :label="$t('original.The_serial_number')" width="50">
                    <template slot-scope="scope" center>
                        {{ (params.pageIndex - 1) * 10 + scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column prop="RealName" :label="$t('original.name')"></el-table-column>
                <el-table-column prop="UserID" :label="$t('original.languages79')"></el-table-column>
                <el-table-column prop="Sex" :label="$t('original.gender')"></el-table-column>
                <el-table-column prop="Birthday" :label="$t('original.languages256')"></el-table-column>
                <el-table-column prop="TheEntranceDate" :label="$t('original.languages171')"></el-table-column>
                <el-table-column prop="DeptID" :label="$t('original.class_name')"></el-table-column>
                <el-table-column prop="PaperName" :label="$t('original.Name_of_scale')" ></el-table-column>
                <el-table-column prop="Status" :label="$t('original.languages564')">
                    <template v-slot="scope">
                        <span v-if="scope.row.Status==1" style="color: #15BF6D;">{{$t('original.languages172')}}</span>
                        <span v-else>{{$t('original.languages173')}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="PaperScoreR" :label="$t('original.languages565')"></el-table-column>
                <el-table-column prop="PaperScoreS" :label="$t('original.languages566')"></el-table-column>
                <el-table-column prop="WarningID" :label="$t('original.languages144')">
                    <template v-slot="scope">
                        <el-button type="primary" :style="{background:scope.row.WarningIDColor,border:'none'}">{{ scope.row.WarningID }}</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="SeTime" :label="$t('original.languages152')"></el-table-column>
                <el-table-column :label="$t('original.languages49')">
                    <template v-slot="scope">
                        <el-button type="text" @click="viewreport(scope.row)" v-if="scope.row.Status==1">{{$t('original.languages567')}}</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination @current-change="handleCurrentChange" hide-on-single-page :current-page.sync="params.pageIndex" :page-size="params.pageSize" layout="total, prev, pager, next" :total="params.Total"></el-pagination>

        </div>
    </div>
</template>
<script>
export default{
    name:'Testquery',
    data() {
        return {
            loading:false,
            checkList:[],
            radio:'',
            YearList:[],
            nationList:[],
            queryscaletestlist:[],
            SubjectPublish:[],
            optionsnew:[],
            params:{
                pageIndex:1,
                pageSize:10,
                Total:0,
                ifSPublishID:[],
                ifS:0,
                study:'',
                sex:'',
                ifTest:'',
                nation:'',
                ifTest:'',
                from:{
                    searchData:'',
                    publishID:'',
                    objectS:'',
                    studyTime:'',
                    scaleName:'',
                    testTime:this.Global.querycensus(6),
                    name:'',
                    warning:[],
                    student:'',
                }
            }
        }
    },
    created() {
        this.DictionaryList();
        this.GetSubjectPublish();
        this.GetDeprtMentByNode();
        let nowYear = new Date().getFullYear() + 1;
        for (let i = 0; i < 10; i++) {
            this.YearList.push(nowYear - i);
        }
    },
    methods: {
        // 搜索
        searchlist(){
            this.params.pageIndex = 1;
            this.getqueryscaletestlist();
        },
        // 发布主题
        GetSubjectPublish(){
            this.$Http_Post('EmphasisClarification/GetSubjectPublish').then(res=>{
                if(res.Code == 0 || res.Code == 200){
                    this.SubjectPublish = res.Data;
                    this.params.from.publishID = res.Data[0].PublishID;
                    this.getqueryscaletestlist();
                }
            });
        },
        // 获取发布对象
        GetDeprtMentByNode(){
            this.$Http_Post('/DepartMent/GetDeprtMentByNode',{DeptID:'',content:''}).then((res) => {
                if (res.Data) {
                    this.optionsnew = res.Data;
                    // this.params.from.objectS = res.Data[0].DeptID;
                }
            });
        },
        // 获取民族
        DictionaryList(){
            this.$Http_Post('User/GetDictionaryList',{DicTypCode:"22"}).then((res) => {
                if (res.Code == 200 || res.Code == 0) {
                    this.nationList = res.Data;
                }
            })
        },
        // 重置
        react(){
            this.params = this.$options.data().params;
            this.getqueryscaletestlist();
        },
        getqueryscaletestlist(){
            this.loading=true;
            this.$Http_Post('querypaper/queryscaletestlist',this.params).then(res=>{
                this.loading=false;
                if(res.Code==0 || res.Code==200){
                    if(this.params['ifS']==1){
                        location.href = res.Data;
                        this.params['ifS']=0;
                        this.params['ifSPublishID']=[];
                    }else{
                        this.params.Total=res.Counts;
                        this.queryscaletestlist=res.Data;
                    }
                }else{
                    this.$message({type: 'error', message:res.Message});
                }
            })
        },
        // 查看报告
        viewreport(e){
            location.href='/visitors/zReportnewShow?PaperResultID='+e.PaperResultID+'&ReportType=2'
        },
        // 选择发布对象
        bumen(dt) {
            let obj = this.optionsnew[0];
            for (let i = 0; i < this.optionsnew.length; i++) {
                if (this.optionsnew[i].DeptID == dt[dt.length - 1]) {
                    obj = this.optionsnew[i];
                    break;
                } else if (this.optionsnew[i].fuzi && this.optionsnew[i].children.length > 0 && this.optionsnew[i].children[0].DeptID != '-1') {
                    obj = this.GetNodeByDeptID(
                        dt[dt.length - 1],
                        this.optionsnew[i].children
                    );
                }
            }
            let _this = this;
            if (obj.fuzi && obj.children.length > 0 && obj.children[0].DeptID == '-1') {
                obj.children = [{ label: this.$t('original.languages22')}];
                this.$Http_Post('/DepartMent/GetDeprtMentByNode',{DeptID:dt[dt.length-1],content:''}).then((res) => {
                    if (res.Code == 200 || res.Code == 0 && res.Data) {
                        obj.children = res.Data;
                    }
                });
            }
        },
        GetNodeByDeptID(ID, NodeList) {
            let obj = null;
            for (let i = 0; i < NodeList.length; i++) {
                if (NodeList[i].DeptID == ID) {
                    obj = NodeList[i];
                    break;
                } else if (
                    NodeList[i].fuzi && NodeList[i].children.length > 0 && NodeList[i].children[0].DeptID != '-1'
                ) {
                    obj = this.GetNodeByDeptID(ID, NodeList[i].children);
                    if (obj != null) break;
                }
            }
            return obj;
        },
        // 关闭弹窗
        Selected_to_shut_dow(dt) {
            this.params.from.objectS = dt[dt.length - 1];
            this.$refs.wcascader.dropDownVisible = false;
        },
        // 选中
        handleSelectionChange(val){
            this.params.ifSPublishID = [];
            for(let item of val){
                this.params.ifSPublishID.push(item.PaperResultID);
            }
        },

        // 分页
        handleCurrentChange(val){
            this.params.pageIndex = val;
            this.getqueryscaletestlist();
        },
        // 导出
        clickexport(){
            if(this.params.ifSPublishID.length<=0){
                this.$message({type: 'error',message:"没有可导出的数据"});
                return false;
            }
            this.params['ifS']=1;
            this.getqueryscaletestlist();
        },
        // 导出全部
        exoprtall(){
            this.params['ifS']=1;
            this.params['ifSPublishID']=[0];
            this.getqueryscaletestlist();
        }
    },
}
</script>
<style scoped>
.Testquery .header{background: #fff;padding: 20px;}
.Testquery .header .condition{margin-bottom: 10px;}
.Testquery .header .item .el-input{display: inline-block;width:auto;}
.Testquery .header .item span{display:inline-block;width: 80px;}
.Testquery .header .item{width: 25%;display: inline-block;}
.Testquery .content{background: #fff;padding: 20px;margin: 20px 0;}
</style>